import { render, staticRenderFns } from "./ExpensePaymentsAndCreditsModal.vue?vue&type=template&id=4b2a6c60"
import script from "./ExpensePaymentsAndCreditsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExpensePaymentsAndCreditsModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ExpensePaymentsAndCreditsModal.vue?vue&type=style&index=0&id=4b2a6c60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports